import axios from 'axios';

const API = `${window.location.origin}/api`;

const api = axios.create({ baseURL: API, withCredentials: true });

export const fetchFeatured = (month) => api.get('/products/featured', { params: month ? { month } : {} });
export const fetchProduct = (id) => api.get(`/products/${id}`);
export const mockCheckout = (data) => api.post('/checkout', data);
export const createCheckoutSession = (data) => api.post('/checkout/create-session', data);
export const getCheckoutStatus = (sessionId) => api.get(`/checkout/status/${sessionId}`);
export const trackEvent = (data) => api.post('/analytics/track', data).catch(() => {});
export const trackProductVisit = (campaignId, productUrl) => api.post(`/products/${campaignId}/track-visit`, { product_url: productUrl }).catch(() => {});
export const seedData = () => api.post('/seed');
export const seedReviews = () => api.post('/seed-reviews');
export const fetchSocialProof = (campaignId) => api.get(`/products/${campaignId}/social-proof`);
export const postReview = (campaignId, data) => api.post(`/products/${campaignId}/reviews`, data);

// Admin
export const getAdminCampaigns = () => api.get('/admin/campaigns');
export const createCampaign = (data) => api.post('/admin/campaigns', data);
export const updateCampaign = (id, data) => api.put(`/admin/campaigns/${id}`, data);
export const deleteCampaign = (id) => api.delete(`/admin/campaigns/${id}`);
export const getAnalyticsSummary = () => api.get('/admin/analytics/summary');
export const getAnalyticsEvents = (params) => api.get('/admin/analytics/events', { params });
export const getAnalyticsDaily = (days) => api.get('/admin/analytics/daily', { params: { days } });
export const getAdminUsers = () => api.get('/admin/users');
export const setUserRole = (userId, role) => api.put(`/admin/users/${userId}/role`, { role });

// Discount Codes
export const getDiscountCodes = () => api.get('/admin/discount-codes');
export const createDiscountCode = (data) => api.post('/admin/discount-codes', data);
export const updateDiscountCode = (id, data) => api.put(`/admin/discount-codes/${id}`, data);
export const deleteDiscountCode = (id) => api.delete(`/admin/discount-codes/${id}`);
export const generateCode = () => api.post('/admin/discount-codes/generate');
export const validatePromo = (data) => api.post('/validate-promo', data);

// Admin Reviews
export const getAdminReviews = (campaignId) => api.get('/admin/reviews', { params: campaignId ? { campaign_id: campaignId } : {} });
export const createAdminReview = (data) => api.post('/admin/reviews', data);
export const updateAdminReview = (id, data) => api.put(`/admin/reviews/${id}`, data);
export const deleteAdminReview = (id) => api.delete(`/admin/reviews/${id}`);

// Site Settings
export const getSiteSettings = () => api.get('/admin/settings');
export const updateSiteSettings = (data) => api.put('/admin/settings', data);

// Magazine Subscription
export const createSubscriptionSession = (data) => api.post('/subscription/create-session', data);
export const getSubscriptionStatus = (sessionId) => api.get(`/subscription/status/${sessionId}`);
export const getAdminSubscriptions = () => api.get('/admin/subscriptions');
export const cancelAdminSubscription = (id) => api.post(`/admin/subscriptions/${id}/cancel`);
export const getAdminSubscriptionInvoices = (id) => api.get(`/admin/subscriptions/${id}/invoices`);
